import { render, staticRenderFns } from "./VAutocompleteAdd.vue?vue&type=template&id=f151305a"
import script from "./VAutocompleteAdd.vue?vue&type=script&lang=js"
export * from "./VAutocompleteAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports